/* ==========================================================================
   LAX · EUROTAFF — REGALOS AUTOMÁTICOS (dos escalones)
   --------------------------------------------------------------------------
   Mete en el carrito los productos regalo (productos a 0 € con etiqueta
   "regalo") cuando se cumple su condición, y los quita cuando deja de
   cumplirse:
     · regalo 1 (aceite): el subtotal de lo demás llega a su umbral (120 €)
       o hay un kit en el carrito (≥ 2 líneas con la propiedad _kit).
     · regalo 2 (gel 4 L): el subtotal llega a su umbral (210 €).
   No usa descuentos automáticos de Shopify a propósito: los códigos de la
   tienda no combinan con descuentos de producto y el regalo desaparecería
   en cuanto el cliente metiera un código.

   Cómo se entera de que el carrito ha cambiado: parchea fetch/XHR y mira las
   llamadas a /cart/add|change|update|clear del tema y de las apps. Sus
   propias llamadas llevan la cabecera X-LAX-Regalo para no re-entrar.
   Config: window.LAX_REGALO.regalos (snippets/lax-regalo-datos.liquid).
   ========================================================================== */
(function () {
  'use strict';
  var C = window.LAX_REGALO;
  var REGALOS = (C && C.activo && C.regalos) ? C.regalos.filter(function (g) { return g && g.variante; }) : [];
  if (!REGALOS.length) return;

  var R = window.routes || {};
  var URL_ADD = (R.cart_add_url || '/cart/add') + '.js';
  var URL_UPDATE = (R.cart_update_url || '/cart/update') + '.js';
  var ocupado = false, pendiente = false, timer = null, rafaga = 0;
  var bloqueados = {};   /* regalos que no volvemos a intentar en esta página (agotado, precio ≠ 0…) */

  function regaloDe(it) {
    for (var i = 0; i < REGALOS.length; i++) {
      var g = REGALOS[i];
      if (it.variant_id === g.variante || (it.product_id && it.product_id === g.producto_id)) return g;
    }
    return null;
  }

  /* Estado del carrito: subtotal real (sin regalos), si hay kit, y las líneas de cada regalo. */
  function estado(cart) {
    var real = 0, nKit = 0, lineas = {};
    (cart.items || []).forEach(function (it) {
      var g = regaloDe(it);
      if (g) { (lineas[g.id] = lineas[g.id] || []).push(it); return; }
      real += it.final_line_price;
      if (it.properties && it.properties._kit) nKit += 1;
    });
    /* Un kit son al menos dos líneas con _kit: si el cliente quita el producto
       principal y deja solo el gel, el regalo se retira. */
    var porKit = nKit >= 2;
    var st = { real: real, kit: porKit, regalos: {} };
    REGALOS.forEach(function (g) {
      st.regalos[g.id] = { g: g, lineas: lineas[g.id] || [], cumple: real >= g.umbral || (!!g.conKit && porKit) };
    });
    return st;
  }

  /* Secciones a re-pintar tras tocar el carrito (cajón + burbuja + página /cart si está). */
  function secciones() {
    var ids = ['cart-drawer', 'cart-icon-bubble'];
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) { if (document.getElementById(id)) ids.push(id); });
    return ids;
  }
  function html(s) { return new DOMParser().parseFromString(s, 'text/html'); }
  function refrescar(datos) {
    if (!datos || !datos.sections) return;
    var d = document.querySelector('cart-drawer');
    var abierto = d && (d.classList.contains('active') || d.classList.contains('is-open') || d.hasAttribute('open'));
    if (d && datos.sections['cart-drawer']) {
      if (abierto && typeof d.renderContents === 'function') {
        d.renderContents(datos);            /* re-pinta y mantiene el cajón abierto como haría el tema */
      } else {
        var nuevo = html(datos.sections['cart-drawer']).querySelector('#CartDrawer');
        var actual = document.getElementById('CartDrawer');
        if (nuevo && actual) {
          actual.innerHTML = nuevo.innerHTML;
          var velo = actual.querySelector('#CartDrawer-Overlay');
          if (velo && typeof d.close === 'function') velo.addEventListener('click', d.close.bind(d));
        }
        if (d.classList.contains('is-empty') && (datos.item_count || (datos.items && datos.items.length))) d.classList.remove('is-empty');
      }
    }
    var b = document.getElementById('cart-icon-bubble');
    if (b && datos.sections['cart-icon-bubble']) {
      var nb = html(datos.sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (nb) b.innerHTML = nb.innerHTML;
    }
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el || !datos.sections[id]) return;
      var n = html(datos.sections[id]).querySelector('.js-contents');
      var a = el.querySelector('.js-contents');
      if (n && a) a.innerHTML = n.innerHTML;
    });
    document.dispatchEvent(new CustomEvent('lax:regalo', { detail: { estado: datos } }));
  }

  function peticion(url, cuerpo) {
    cuerpo.sections = secciones().join(',');
    cuerpo.sections_url = window.location.pathname;
    return window.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-LAX-Regalo': '1' },
      body: JSON.stringify(cuerpo)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, datos: j }; }); });
  }

  function sincronizar(cart) {
    var st = estado(cart);
    document.dispatchEvent(new CustomEvent('lax:regalo-estado', { detail: st }));
    if (ocupado || rafaga > 6) return;   /* rafaga: freno por si algo re-disparase en bucle */
    var updates = {}, hayUpdates = false, anadir = [];
    REGALOS.forEach(function (g) {
      var e = st.regalos[g.id], l = e.lineas, p = l[0];
      l.slice(1).forEach(function (it) { updates[it.key] = 0; hayUpdates = true; });   /* duplicados fuera */
      if (p) {
        if (p.final_line_price > 0) {
          /* Salvaguarda: si por lo que sea el regalo no sale a 0 €, fuera y no insistimos. */
          bloqueados[g.id] = true; updates[p.key] = 0; hayUpdates = true;
        } else if (!e.cumple) {
          updates[p.key] = 0; hayUpdates = true;
        } else if (p.quantity > 1) {
          updates[p.key] = 1; hayUpdates = true;
        }
      } else if (e.cumple && !bloqueados[g.id]) {
        anadir.push({ id: g.variante, quantity: 1, properties: { _regalo: g.nombre || '1' } });
      }
    });
    var op = null, anadiendo = false;
    if (hayUpdates) op = peticion(URL_UPDATE, { updates: updates });
    else if (anadir.length) { anadiendo = true; op = peticion(URL_ADD, { items: anadir }); }
    if (!op) { rafaga = 0; return; }
    ocupado = true; rafaga++;
    op.then(function (res) {
      if (res.ok) {
        refrescar(res.datos);
        document.dispatchEvent(new CustomEvent('cvr:carrito'));
        pendiente = true;   /* tras quitar puede tocar añadir (o al revés): otra pasada */
      } else if (anadiendo) {
        /* p. ej. regalo agotado: no volvemos a intentarlo en esta página */
        anadir.forEach(function (a) { REGALOS.forEach(function (g) { if (g.variante === a.id) bloqueados[g.id] = true; }); });
      }
    }).catch(function () {}).then(function () {
      ocupado = false;
      if (pendiente) { pendiente = false; comprobar(); }
    });
  }

  function comprobar() {
    if (ocupado) { pendiente = true; return; }
    window.fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(sincronizar)
      .catch(function () {});
  }
  function programar() { clearTimeout(timer); rafaga = 0; timer = setTimeout(comprobar, 80); }

  /* ---- Detectar cambios del carrito hechos por el tema o por apps ---- */
  var RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var fetchOriginal = window.fetch;
  window.fetch = function (entrada, opciones) {
    var p = fetchOriginal.apply(this, arguments);
    try {
      var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
      var propia = opciones && opciones.headers && (opciones.headers['X-LAX-Regalo'] || (typeof opciones.headers.get === 'function' && opciones.headers.get('X-LAX-Regalo')));
      if (RE.test(url) && !propia) p.then(programar, function () {});
    } catch (e) {}
    return p;
  };
  var abrir = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (metodo, url) {
    try { if (RE.test(String(url))) this.addEventListener('loadend', programar); } catch (e) {}
    return abrir.apply(this, arguments);
  };
  document.addEventListener('cart:refresh', programar);
  document.addEventListener('cvr:carrito', programar);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', comprobar); else comprobar();
})();
